import {
  GetSecretValueCommand,
  SecretsManagerClient,
} from "@aws-sdk/client-secrets-manager";

const secretsManagerClient = new SecretsManagerClient({});

export const getSecret = async (secretArn: string) => {
  const command = new GetSecretValueCommand({ SecretId: secretArn });
  const response = await secretsManagerClient.send(command);

  if (response.SecretString) {
    return response.SecretString;
  }

  throw new Error("Secret value is not available in plain text format.");
};
